import React, { useState } from "react";
import { useApi } from "../../../hooks/useApi";
import api from "../../../utils/api";
import "./Customers.scss";

const Customers = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, loading } = useApi(() => api.getAdminCustomers(), []);

  const customers = data?.customers || [];
  const filteredCustomers = customers.filter(
    (customer) =>
      customer.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      `${customer.firstName} ${customer.lastName}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="admin-customers">
      <div className="customers-header">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search customers by name or email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading customers...</div>
      ) : (
        <div className="customers-table">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers.length === 0 ? (
                <tr>
                  <td colSpan="4" className="empty-state">
                    No customers found
                  </td>
                </tr>
              ) : (
                filteredCustomers.map((customer) => (
                  <tr key={customer.id}>
                    <td>#{customer.customerId}</td>
                    <td>
                      {customer.firstName} {customer.lastName}
                    </td>
                    <td>{customer.email}</td>
                    <td>
                      <button className="btn-view">👁️ View Details</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Customers;
